import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

import classes from "./AspireLogo.module.scss";

interface AspireLogoProps {
    isAuthenticated: boolean;
    logo: string;
}

const AspireLogo = ({ isAuthenticated, logo }: AspireLogoProps) => {
    return (
        <Typography variant="h6">
            <Link to={isAuthenticated ? "/newsfeed" : "/"} className={classes.navbarTitle}>
                <img src={logo} alt="logo" className={classes.logo} />
            </Link>
        </Typography>
    );
};

export default AspireLogo;
